/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-empty */
/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { Component } from 'react';
import _ from 'lodash';
import getStudentTardies from '../services/getStudentTardies';
import loader from '../images/loading.gif';
import formatDate from '../services/formatDate';

export default class Tardies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tardyDetails: [],
      loading: true,
      error: '',
      c: 1,
    };
  }

  componentDidMount() {
    setInterval(() => {
      const a = document.getElementsByClassName('tardy-main-div');
      if (a && a.length) {
        const b = a[0];
        if (window.screen.availHeight - 183 < b.scrollHeight) {
          this.setState({ c: 0 });
        }
      }
    }, 0);

    if (!this.props.match.params.id) {
      const { history } = this.props;
      history.replace('/studentDetails');
      return;
    }
    const studentDetails = JSON.parse(localStorage.getItem('studentDetails'));
    if (studentDetails) {
      let data = [];
      data = JSON.parse(localStorage.getItem('tardyDetails'));
      if (data && data.length >= this.props.match.params.id && data[this.props.match.params.id] !== null && data[this.props.match.params.id] !== undefined) {
        this.setState({ tardyDetails: data[this.props.match.params.id], loading: false });
      }

      getStudentTardies(studentDetails.school_code,
        studentDetails.student_no,
        studentDetails.student_id,
        this.props.match.params.id)
        .then((res) => {
          if (res.data) {
            this.setState({ tardyDetails: res.data.tardyDetails, loading: false });
            let tardyDetails = JSON.parse(localStorage.getItem('tardyDetails'));
            if (tardyDetails) {
              tardyDetails[this.props.match.params.id] = res.data.tardyDetails;
              const updatedData = res.data.tardyDetails;
              const result = _.isEqual(updatedData, data[this.props.match.params.id]);
              if (result === false) {
                 // console.log('Updated Tardy');
                this.setState({ tardyDetails: res.data.tardyDetails, loading: false });
                localStorage.setItem('tardyDetails', JSON.stringify(tardyDetails));
              }
            } else {
              tardyDetails = [];
              tardyDetails[this.props.match.params.id] = res.data.tardyDetails;
            }
            localStorage.setItem('tardyDetails', JSON.stringify(tardyDetails));
            const date = new Date();
            const formattedDate = formatDate(date);
            const detentionTime = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} at ${formattedDate[0]}:${formattedDate[1]} ${(formattedDate[2]).split(' ')[1]}`;
            let time = JSON.parse(localStorage.getItem('tardiesCacheTime'));
            if (time) {
              time[this.props.match.params.id] = JSON.stringify(detentionTime);
            } else {
              time = [];
              time[this.props.match.params.id] = JSON.stringify(detentionTime);
            }
            localStorage.setItem('tardiesCacheTime', JSON.stringify(time));
          } else {
            this.setState({ tardyDetails: [], loading: false });
          }
        })
        .catch(() => {
          const res = JSON.parse(localStorage.getItem('tardyDetails'));
          const pageTime = JSON.parse(localStorage.getItem('tardiesCacheTime'));
          const date = pageTime[this.props.match.params.id] || JSON.stringify('25/03/2020 at 16:20');
          this.setState({ error: `You are offline. Last update for Tardies was at ${date.split('"')[1]}`, loading: false, tardyDetails: res[this.props.match.params.id] || [] });
          // setTimeout(() => this.setState({ error: '' }), 10000);
        });
    } else {
      const { history } = this.props;
      history.replace('/');
    }
  }

  render() {
    const {
      loading, error, tardyDetails, c,
    } = this.state;
    if (loading) {
      return <img className="menu-loader" src={loader} alt="Loading ..." />;
    }
    const details = [];
    tardyDetails.forEach((element) => {
      details.push({
        id: element.id,
        date: ((element.created).split('T'))[0],
        time: ((((element.created).split('T'))[1]).split('+'))[0],
        period: element.period,
        referral: element.referral_by,
      });
    });

    const detailsView = [];
    details.forEach((element) => {
      detailsView.push(
        <div className="tardy-list" key={element.id}>
          <div>
            <p>
              <span>Date :</span>
              {' '}
              {element.date}
              {' '}
              <span>Time :</span>
              {' '}
              {element.time}
            </p>
            <p>
              <span>Period :</span>
              {' '}
              {element.period}
            </p>
            <p>
              <span>By :</span>
              {' '}
              {element.referral}
            </p>
          </div>
        </div>,
      );
    });
    detailsView.reverse();
    return (
      <div>
        <div className="tardy-header">
          <p>Tardies</p>
          <div
            className="home-btn"
            onClick={() => {
              const { history } = this.props;
              history.replace('/studentDetails');
            }}
            role="button"
            tabIndex={0}
            onKeyPress={() => {}}
          >
            <span><i className="fa fa-home" aria-hidden="true" /></span>
          </div>
        </div>
        {error && (
        <div className="offline-banner-tardy">
          {error}
        </div>
        )}
        <div className="tardy-list-wrapper" style={{ padding: 5, marginTop: 65, paddingBottom: 80 }}>
          <div className="tardy-main-div">
            { detailsView.length ? detailsView : <p className="no-data">Nothing to show here!</p>}
          </div>
        </div>
        <div
          className={c === 1 ? 'back-btn non-float' : 'back-btn'}
          style={c === 1 ? { left: (window.screen.width * 0.27) } : null}
          onClick={() => {
            const { history } = this.props;
            history.push('/studentSchedule');
          }}
          role="button"
        >
          <p> &lt; Back</p>
        </div>
      </div>
    );
  }
}
